import React from 'react'
import "./wallet.scss"
import Header from '../landing/Header/Header'

const HighRisk = () => {
    return (
        <>
            <Header />
            <section className="wallet-not-found">
                <div className="custom-container">
                    <div className="parent">
                        <img src="\assets\walleterror.svg" alt="img" className='img-fluid' />
                        <h5>High Risk Alert</h5>
                        <p>
                            Unfortunately, our compliance system has flagged your wallet as high-risk. As a result, we cannot accept investments from this wallet according to our Terms and Conditions.
                            <br /><br />
                            We will refund your funds to the original wallet. To facilitate this, please fill out the following form with your details:
                            <br /><br />
                            <a href="https://forms.gle/1Fuc28YjBh2B7S3x7" target='_blank'>https://forms.gle/1Fuc28YjBh2B7S3x7</a>
                            <br /><br />
                            We apologize for any inconvenience this may cause.
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HighRisk
